/**
 * Post Recommend Listener
 * - addEventListener registration only
 */

import { postRecommendForm } from "./post-recommend-form";

interface PostRecommendListenerDeps {
    handler: {
        handleRecommendClick(event: MouseEvent, el: HTMLElement): Promise<void>;
    };
}

class PostRecommendListener {
    public handler: PostRecommendListenerDeps["handler"];
    public _registered: boolean;

    public constructor(deps: PostRecommendListenerDeps) {
        this.handler = deps.handler;
        this._registered = false;
    }

    public register(): void {
        if (this._registered) return;
        this._registered = true;

        document.addEventListener(
            "click",
            (e) => {
                if (!(e instanceof MouseEvent)) {
                    return;
                }
                const event = e;
                const target = event.target;
                if (!(target instanceof Element)) {
                    return;
                }
                if (!target) return;

                const crownEl = postRecommendForm.getClosestRecommendButton(target);
                if (crownEl instanceof HTMLElement) {
                    const canRecommend = postRecommendForm.getRecommendCapabilityHost(crownEl) !== null;
                    if (canRecommend) {
                        void this.handler.handleRecommendClick(event, crownEl);
                    }
                }
            },
            { capture: true },
        );
    }
}

export { PostRecommendListener };
